"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "Add a custom color",
  Apply: "Apply",
  "Apply color": "Apply color",
  Automatic: "Automatic",
  Cancel: "Cancel",
  "Cancel color": "Cancel color",
  Change: "Change",
  Custom: "Custom",
  "Custom color picker": "Custom color picker",
  "Invalid hex value": "Invalid hex value",
  Remove: "Remove",
  "Select color {color}": ["Select color ", ["color"]],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["You’ve reached the ", ["maxCustomColors"], " custom colors limit. To add another color, remove one first."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map